import OperatorCompanyHelper from "../../Components/Company/Index";

const OperatorCompanyPage = () => {
  return <OperatorCompanyHelper />;
};

export default OperatorCompanyPage;
